import { landmarkQuiz } from "./landmark-quiz"
import { theWolfQuiz } from "./the-wolf-quiz"
import { defaultQuestion } from '../store/util'
import { currentUser } from '../lib/user'

export default {
    mounted() {
        const mergeDefaultQuestion = (question) => ({
             ...defaultQuestion(),
             ...question
        });

        landmarkQuiz.questions = landmarkQuiz.questions.map(mergeDefaultQuestion)
        theWolfQuiz.questions = theWolfQuiz.questions.map(mergeDefaultQuestion)

        // removing all non-digit characters from user id to check even/odd
        const userId = currentUser().id
        const numericId = userId.replace(/\D/g, '');
        const isEven = Number(numericId) % 2 === 0;

        if(!window.exampleQuiz) {
            window.exampleQuiz = isEven ? landmarkQuiz : theWolfQuiz
        }
    },

    methods: {
        exampleQuiz() {
            return window.exampleQuiz || landmarkQuiz
        }
    }
}
